import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';
import { TlkCardComponent } from '@itero/ui-toolkit-angular/card';
import { PatientModule } from '@modules/patient/patient.module';
import { PatientAppIframeCommunicationService } from '@modules/patient/services/patient-app-iframe-communication.service';
import { PatientAppLoadStateService } from '@modules/rx-for-doctor/services/patient-app-load-state.service';
import { TranslateModule } from '@ngx-translate/core';
import { BaseDestroyableComponent } from '@shared/base-classes/base-destroyable';
import { takeUntil, tap } from 'rxjs';
import { RxIntuitivePatientDetailsFacade } from './rx-intuitive-patient-details.facade';

@Component({
	selector: 'rx-intuitive-patient-details',
	templateUrl: './rx-intuitive-patient-details.component.html',
	styleUrls: ['./rx-intuitive-patient-details.component.scss'],
	imports: [PatientModule, TlkButtonComponent, TlkCardComponent, TranslateModule, AsyncPipe],
	providers: [RxIntuitivePatientDetailsFacade],
	standalone: true
})
export class RxIntuitivePatientDetailsComponent extends BaseDestroyableComponent implements OnDestroy {
	@Input() isCreateDisabled = false;
	@Output() patientCreated = new EventEmitter<void>();

	isPatientAppReady$ = this.patientAppLoadStateService.isPatientReadyAndLoaded$;
	isValidToSave$ = this.rxIntuitiveForDoctorFacade.validatePatientDetailsForSave();

	constructor(
		private readonly rxIntuitiveForDoctorFacade: RxIntuitivePatientDetailsFacade,
		private readonly patientAppIframeCommunicationService: PatientAppIframeCommunicationService,
		private readonly patientAppLoadStateService: PatientAppLoadStateService
	) {
		super();
	}

	onCreateClick(): void {
		this.rxIntuitiveForDoctorFacade
			.savePatientDetails()
			.pipe(
				takeUntil(this.componentAlive$),
				tap(canProceed => {
					if (canProceed) {
						this.patientCreated.emit();
					}
				})
			)
			.subscribe();
	}

	ngOnDestroy(): void {
		this.setPatientAppReadyState(false);
		super.ngOnDestroy();
	}

	private setPatientAppReadyState(isReady: boolean): void {
		this.patientAppIframeCommunicationService.setPatientAppReadyState(isReady);
	}
}
